export default __webpack_public_path__ + "static/media/industry11.74a9f931.png";